import { render } from "./latestNotifications.vue?vue&type=template&id=1bed751a"
import script from "./latestNotifications.vue?vue&type=script&lang=js"
export * from "./latestNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__